<template>
    <div>
      <a-popover placement="bottom" v-if="filters.length">
        <template slot="title">
          Filter By
          <a-divider type="vertical" />
          <a href="#" @click.prevent="resetFilter" class="pull-right">Reset Filter</a>
        </template>
        <template slot="content">
          <a-row type="flex" justify="space-between">
            <a-col v-for="filter in filters" :key="filter.id" style="padding-right: 10px">
              <p>{{ filter.category }}</p>
              <a-radio-group
                  v-if="filter.type === 'radio'"
                  v-model="radioModel"
                  @change="filterChange(filter.id, filter.type)">
                    <a-radio v-for="input in filter.inputs"
                             :key="input.value"
                             :style="radioStyle"
                             :value="input.value">
                      {{ input.label }}
                    </a-radio>
              </a-radio-group>
              <a-checkbox-group
                  v-model="filter.value"
                  v-if="filter.type === 'checkbox'"
                  @change="filterChange(filter.id, filter.type, filter.value)"
              >
                <a-checkbox
                            v-for="input in filter.inputs"
                            :key="input.value"
                            :style="radioStyle"
                            :value="input.value">
                  {{ input.label }}
                </a-checkbox>
              </a-checkbox-group>
              <a-divider type="vertical" />
            </a-col>
          </a-row>
        </template>
        <a-button icon="filter">Filter</a-button>
      </a-popover>
  </div>
</template>
<script>
export default {
  props: {
    filters: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      radioModel: null,
      checkboxModel: [],
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
        marginLeft: '0px',
      }
    };
  },

  methods: {

    resetFilter() {
      this.radioModel = null;
      this.checkboxModel = [];

      this.filters.forEach(filter => {
        if (filter.type === 'checkbox') {
          filter.value = [];
        }
      })

      this.filterChange();
    },

    filterChange(id, type, value) {
      let form = {};

      switch (type) {
        case 'radio' :
          form = {
            category: id,
            type: type,
            value: this.radioModel,
          }
          break;
        case 'checkbox':
          form = {
            category: id,
            type: type,
            value: value,
          }
          break;
        default:
          form = {
            id: null,
            type: null,
            value: null,
          };
          break;
      }

      this.$emit('filterChanged', form);
    }
  }
}
</script>